<script setup lang="ts">
import { DialogContent, DialogOverlay, DialogPortal, DialogRoot, DialogTitle } from 'reka-ui';
import NavLinks from './NavLinks.vue';

const open = defineModel<boolean>('open', { required: true });
</script>

<template>
  <DialogRoot v-model:open="open">
    <DialogPortal>
      <DialogOverlay class="drawer-overlay" />
      <DialogContent class="drawer" aria-describedby="">
        <DialogTitle class="sr-only">Navigation</DialogTitle>
        <NavLinks @navigate="open = false" />
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
